import Menu from "../../CONTAINERS/menu/menu";

import { OverlayTrigger, Modal, Spinner, Alert, Container, Row, Col, Card, Pagination, Form, Stack, InputGroup, ProgressBar } from "react-bootstrap";

import { ConfigProvider, Button, Space, Tooltip, Image, Select, DatePicker, Checkbox, Input, Switch } from 'antd';

import type { InputNumberProps } from 'antd';
import { InputNumber } from 'antd';

import { useLocation } from 'react-router-dom';
import { ESTILOS_COLORES } from "../../API/CONSTANTS/constants";
import { useEffect, useState } from "react";
import { creaTicketRegistroTopdesk, traerUsuarioTopdesk } from "./Services/OperadoresBC";

import logoSTK from "../../ASSETS/images/logo-starken.png";
import AlertaCentral from "../../SHARED/CentralAlertas";

export default function IngresoBC(props: any) {

    const { history } = props;    // para los cambios de pagina

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    let dato = params.get('usuario');

    const [showU, setShowU] = useState(false);
    const [selectBoton, setSelectBoton] = useState(false);
    const [orden_flete, setOrden_flete] = useState("");

    const onChangeInput: InputNumberProps['onChange'] = (value) => {


        let largo: number = (value != null) ? String(value).length : 0;

        let OrdenFlete: string = (value != null) ? String(value) : "";

        if (largo > 5) {
            setSelectBoton(true);
            setOrden_flete(OrdenFlete);
        } else {
            setSelectBoton(false);
        }



     
    };

    const Color_Main_BackGround = ESTILOS_COLORES.MAIN_BACKGROUND;
    const Color_Sucursales = ESTILOS_COLORES.SUCURSALES;
    const Color_Colores = ESTILOS_COLORES.COLORES;
    const Color_Tickets = ESTILOS_COLORES.TICKETS;
    const Color_Fechas = ESTILOS_COLORES.FECHAS;
    const Color_PalabrasClaves = ESTILOS_COLORES.PALABRAS_CLAVES;
    const Color_BackGround_Limpieza = ESTILOS_COLORES.BACKGROUND_LIMPIEZA;
    const Color_Limpieza = ESTILOS_COLORES.LIMPIEZA;
    const Color_Blanco = ESTILOS_COLORES.BLANCO;
    const Color_Verde = ESTILOS_COLORES.VERDE;
    const Color_Rojo = ESTILOS_COLORES.ROJO;

    const Color_Ticket_SinEstado = ESTILOS_COLORES.TICKET_SIN_ESTADO;
    const Color_Ticket_Original = ESTILOS_COLORES.TICKET_ORIGINAL;
    const Color_Ticket_Redestinado = ESTILOS_COLORES.TICKET_REDESTINADO;
    const Color_Ticket_Devuelto = ESTILOS_COLORES.TICKET_DEVUELTO;
    const Color_Ticket_Rezago = ESTILOS_COLORES.TICKET_REZAGO;
    const Color_Ticket_Sobrante = "LemonChiffon";

    const Color_Encabezado = ESTILOS_COLORES.ENCABEZADO;
    const Color_Footer = ESTILOS_COLORES.FOOTER;
    const Color_Gris = ESTILOS_COLORES.GRIS;
    const Color_Negro = ESTILOS_COLORES.NEGRO;
    const Color_Verde_Agua = ESTILOS_COLORES.VERDE_AGUA;
    const Color_Amarillo_Canario = ESTILOS_COLORES.AMARILLO_CANARIO;

    const [cambio, setCambio] = useState(false);

    const onChange = (checked: boolean) => {
 

        setCambio(checked);



    };


    useEffect(() => {
    }, [selectBoton]);

    async function continuar() {
        setShowU(true);

        let usuario = await traerUsuarioTopdesk(dato);

        let Id_Usuario = usuario.data[0].id;



        let ticket: any = await crearTicketRegistro(Id_Usuario, dato, cambio, orden_flete);

        if (ticket.status == 201) {

            setTimeout(() => {
                setShowU(false);                
                paginaSiguiente();
            }, 10);

        } else {
            setShowU(false);
            AlertaCentral("ERRORTIECKETREGISTRO", "", "", "", "");
        }
    }


    async function crearTicketRegistro(id: any, nombreLoggin: any, tieneof: boolean, orden_flete?: any) {

        let TieneOrden = "";

        if (cambio) {
            TieneOrden = "Con OF";
        } else {
            TieneOrden = "Sin Of";
        }

        let body = {
            "callerLookup": {
                "id": id
            },
            "status": "firstLine",
            "briefDescription": "Ingreso Galería Bulto Ciego",
            "request": `<b> DATOS </b> <br /> <br />nombre: ${nombreLoggin} <br /> Tiene OF: ${tieneof} <br /> N°OF: ${orden_flete}`,
            "category": {
                "name": "Ingreso Galería Bulto Ciego"
            },
            "subcategory": {
                "name": TieneOrden //CON FO para cuando tenga y Sin OF cuando no.
            },
            "optionalFields1": {

                "text2": orden_flete,
            },
            "processingStatus": {
                "name": "Cerrado"
            }
        }

        let respuesta = await creaTicketRegistroTopdesk(body);

        return respuesta;
    }


    function paginaSiguiente() {
        history.push("/Main");
    };

    return (
        <>

            {/* MENU */}
            <Menu titulo="Ingreso Galería Bulto Ciego" logo="" />

            <Container
                fluid="xl"
                className="mt-2 mb-2 rounded pt-3 pb-3 shadow"
                style={{ background: Color_Main_BackGround }}
            >

                <div className="rounded shadow border" style={{ background: Color_Blanco }}>

                    <Container fluid="xl" className="text-center mt-3 mb-3" >
                        <Row className="row">

                        </Row>

                        <Row className="mt-4">
                            <Col style={{ color: Color_Verde }} >
                                <b> ¿ {dato}  Tiene Orden de Flete* ? </b>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="d-flex justify-content-end" style={{ color: Color_Verde }} >
                                <b> NO </b>
                            </Col>
                            <Col className="col-1">
                                <Switch onChange={onChange} style={{ background: Color_Verde }} />
                            </Col>
                            <Col className="d-flex justify-content-start" style={{ color: Color_Verde }} >
                                <b>   SI </b>
                            </Col>
                        </Row>
                        <Row hidden={!cambio} className="mt-4">
                            <Col className="d-flex justify-content-end">
                                <label style={{ color: Color_Verde }} >
                                    Ingresar Orden de Flete :
                                </label>
                            </Col>
                            <Col className="d-flex justify-content-start">

                                <InputNumber onChange={onChangeInput} style={{ width: "130px" }} />

                            </Col>
                        </Row>

                        <Row className="mt-4">
                            <Col>
                                {cambio ? (
                                    <>

                                        {selectBoton ? (
                                            // este es cuando tiene una of de mas de 6 digitos
                                            <>
                                                <Button
                                                    type="primary"
                                                    style={{ color: Color_Blanco, backgroundColor: Color_Verde }}
                                                    onClick={() => { continuar(); }}
                                                >
                                                    Continuar
                                                </Button>
                                            </>
                                        ) : (
                                            <>
                                                <Button
                                                    disabled
                                                >
                                                    Continuar
                                                </Button>
                                            </>
                                        )
                                        }
                                    </>
                                ) : (
                                    <>
                                        {/* este es cuando es false y no tiene orden de flete */}
                                        <Button
                                            type="primary"
                                            style={{ color: Color_Blanco, backgroundColor: Color_Verde }}
                                            onClick={() => { continuar(); }}
                                        >
                                            Continuar
                                        </Button>
                                    </>
                                )
                                }
                            </Col>
                        </Row>
                    </Container>
                </div>
            </Container>

            {/* MODAL LOADING */}

            <Modal
                show={showU}
                size="sm"
                backdrop="static"
                keyboard={false}
                name="loading"

            >
                <Modal.Header className="text-center justify-content-center">
                    <img alt="Starken" src={logoSTK} style={{ height: "45px" }} />
                </Modal.Header>
                <Modal.Body  >
                    <Container className="text-center">
                        <Spinner animation="border" role="status" variant="success" size="sm" />
                        <Spinner animation="border" role="status" variant="success" />
                    </Container>
                    <Container className="text-center">
                        <h6 style={{ color: Color_Verde }}>Cargando...</h6>
                    </Container>
                    <hr />
                    <Container className="text-center">

                    </Container>
                </Modal.Body>
            </Modal>


        </>
    );
}